import { render } from "./PostalCardPreviewComponent.vue?vue&type=template&id=03bc22e6&scoped=true&ts=true"
import script from "./PostalCardPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./PostalCardPreviewComponent.vue?vue&type=script&lang=ts"

import "./PostalCardPreviewComponent.vue?vue&type=style&index=0&id=03bc22e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bc22e6"]])

export default __exports__